const FormPopupMessage = () => {

    jQuery(document).ready(function(){
        jQuery(document).on('gform_confirmation_loaded', function(event, formId){
            var formWrap = document.getElementById('form-popup__form--' + formId);
            if (formWrap) {
                // hide form and standard confirmation after submission
                formWrap.style.display = 'none';
            }
            var confrimationWrap = document.getElementById('form-popup__confirmation--' + formId);
            if (confrimationWrap) {
                // show custom form confirmation and download after submission
                confrimationWrap.style.display = 'block';
            }
        });
    })

};

export default FormPopupMessage;